/**
 * Utility functions for sharing palettes without a backend.
 * Encodes palette data into a URL-safe string.
 */

/**
 * Encodes a string to a URL-safe Base64 string, handling Unicode characters.
 */
function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
    }));
}

/**
 * Decodes a URL-safe Base64 string back to a Unicode string.
 */
function b64DecodeUnicode(str) {
    try {
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    } catch (e) {
        console.error("Failed to decode share data", e);
        return null;
    }
}

/**
 * Compresses and encodes palette data.
 * We only need paletteName, emoji, and colors.
 */
export const encodePaletteData = (palette) => {
    const dataToEncode = {
        n: palette.paletteName,
        e: palette.emoji,
        c: palette.colors.map(c => ({ n: c.name, c: c.color }))
    };
    const jsonStr = JSON.stringify(dataToEncode);
    return b64EncodeUnicode(jsonStr);
};

/**
 * Decodes palette data from an encoded string.
 */
export const decodePaletteData = (encodedStr) => {
    const jsonStr = b64DecodeUnicode(encodedStr);
    if (!jsonStr) return null;

    try {
        const data = JSON.parse(jsonStr);
        return {
            paletteName: data.n,
            emoji: data.e,
            id: data.n.toLowerCase().replace(/ /g, "-"),
            colors: data.c.map(c => ({ name: c.n, color: c.c }))
        };
    } catch (e) {
        console.error("Failed to parse decoded palette data", e);
        return null;
    }
};

/**
 * Generates a full shareable URL for a palette.
 */
export const generateShareUrl = (palette) => {
    const encoded = encodePaletteData(palette);
    const baseUrl = window.location.origin;
    return `${baseUrl}/palette/share/${encoded}`;
};
